import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Form/form';
export var FormHelperText = function FormHelperText(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$isError = _a.isError,
      isError = _a$isError === void 0 ? false : _a$isError,
      _a$isHidden = _a.isHidden,
      isHidden = _a$isHidden === void 0 ? true : _a$isHidden,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$icon = _a.icon,
      icon = _a$icon === void 0 ? null : _a$icon,
      props = __rest(_a, ["children", "isError", "isHidden", "className", "icon"]);

  return React.createElement("p", Object.assign({
    className: css(styles.formHelperText, isError && styles.modifiers.error, isHidden && styles.modifiers.hidden, className)
  }, props), icon && React.createElement("span", {
    className: css(styles.formHelperTextIcon)
  }, icon), children);
};